<template>
  <!-- <el-row class="pa-2 fs-vh-100"
    v-loading="loading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  > -->
  <el-row class="pa-2 fs-vh-100">
    <el-col :span="24" class="text-center">
      <div class="close-icon-head" @click="redirectToMenu">
        <i class="el-icon-back"></i>
      </div>
      <el-image
          v-if="BranchDetail"
          class="big-logo"
          :src="'https://images.foodstory.co/' + BranchDetail.logo"
          fit="cover"></el-image>
    </el-col>
    <el-col :span="24" class="text-center auth-text">
      <h3 class="text-title--large" v-html="$t('phoneauth.header')"></h3>
    </el-col>
    <el-col class="p-36">
      <el-form :model="numberValidateForm" ref="numberValidateForm" class="demo-ruleForm">
        <el-form-item
          prop="phoneNumber"
        >
          <label for="phoneNumber" class="text-subtitle">{{ $t('phoneauth.phone') }}</label>
          <!-- :maxlength="selectCountry.length" -->
          <el-input
            id="phoneNumber"
            class="text-subtitle"
            :class="{ 'input-number-error': numberValidateForm.error }"
            type="text"
            inputmode="numeric"
            v-model="numberValidateForm.phoneNumber"
            @keypress.native="isNumber($event)"
            pattern="[0-9]*"
            :placeholder="$t('phoneauth.placeholder1')"
            height="50"
            autocomplete="off"
          >
            <el-select v-model="selectCountry" value-key="value" slot="prepend" placeholder="Select">
              <template slot="prefix">
                <img width="30" height="30" :src="require('@/assets/' + selectCountry.src)" />
              </template>
              <el-option v-for="item in Country" :key="item.value" :label="item.label" :value="item">
                <img width="30" height="30" :src="require('@/assets/' + item.src)"/>
                <label class="fs-al-t text-subtitle">{{ item.label }}</label>
              </el-option>
            </el-select>
          </el-input>
          <div v-show="numberValidateForm.error">
            <span class="color-danger--text text-body ml--16">
              {{ numberValidateForm.error }}
            </span>
          </div>
        </el-form-item>
        <el-form-item>
          <BaseButton 
            :loading="loading" 
            class="fs-confirm mt-2 text-button" 
            @click="authPhoneNumber('numberValidateForm')"
          >
            {{ $t('phoneauth.next') }}
          </BaseButton>
        </el-form-item>
      </el-form>
      <!-- Recap Char Auth Firebase Phone Number -->
      <div id="sign-in-button"></div>
    </el-col>
  </el-row>
</template>
<script>
export default {
  name: 'AuthPhoneNumber',
  props: ['restaurant_uuid', 'branch_uuid'],
  data () {
    return {
      numberValidateForm: { phoneNumber: '', error: '' },
      selectCountry: null,
      loading: false,
      Country: [
        {
          value: 'thai',
          label: 'Thailand',
          src: 'icons/flag-thai.png',
          length: 10
        },
        {
          value: 'laos',
          label: 'Laos',
          src: 'icons/flag-laos.png',
          length: 11
        },
        {
          value: 'aus',
          label: 'Australia',
          src: 'icons/flag-aus.png',
          length: 10
        },
        {
          value: 'ger',
          label: 'Germany',
          src: 'icons/flag-ger.png',
          length: 11
        },
        {
          value: 'india',
          label: 'India',
          src: 'icons/flag-india.svg',
          length: 10
        },
        {
          value: 'myanmar',
          label: 'Myanmar',
          src: 'icons/flag-myanmar.svg',
          length: 11
        }
      ]
    }
  },
  created () {
    this.selectCountry = this.Country[0]
  },
	methods: {
    authPhoneNumber: async function(formName) {
      // if (this.numberValidateForm.phoneNumber.length != this.selectCountry.length) {
      //   this.$alert(this.$t('phoneauth.dialog.title'), this.$t('dialog.alert'), {
      //     confirmButtonText: this.$t('dialog.yes')
      //   })
      // } else {
        return this.$refs[formName].validate(async (valid) => {
          this.loading = true
          if (valid) {
            let phonenumber = this.numberValidateForm.phoneNumber.substr(1)
            switch (this.selectCountry.value) {
              case 'thai': // phone test 088888888 // 888888
                phonenumber = '+66' + phonenumber
                break;
              case 'laos': // phone test 02112345666 // 123456
                phonenumber = '+856' + phonenumber
                break;
              case 'aus': // phone test 0477777777 // 777777
                phonenumber = '+61' + phonenumber
                break;
              case 'ger': // phone test 06912345678 // 123456
                phonenumber = '+49' + phonenumber
                break;
              case 'india': // phone test 01401234567 // 123456
                phonenumber = '+91' + phonenumber
                break;
              case 'myanmar': // phone test 09712345678 // 123456
                phonenumber = '+95' + phonenumber
                break;
              default:
                break;
            }
            try {
              const result = await this.$store.dispatch('verifyPhoneNumber', {
                restaurantAlias: this.restaurant_uuid,
                branchAlias: this.branch_uuid,
                phoneNumber: phonenumber
              })
              this.numberValidateForm.error = ''
              return result
            } catch (error) {
              this.numberValidateForm.phoneNumber = ''
              this.numberValidateForm.error = error.message
              throw error
            } finally {
              this.loading = false
            }
          } else {
            this.loading = false
            return false;
          }
        })
      // }
    },
    redirectToMenu () {
      this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}` })
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
  computed: {
    BranchDetail () {
      return this.$store.getters.BranchDetail
    }
  },
  watch: {
    selectCountry () {
      // Set Empty Phone Number When Change Country
      this.numberValidateForm.phoneNumber = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.input-number-error {
  /deep/ {
    input {
      border: 0.5px solid var(--color-danger);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/verify/AuthPhoneNumber.vue